/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedShippingInfo_item = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedCustomsMessage_item" | "useShippingPrice_item">;
    readonly " $refType": "PdpSharedShippingInfo_item";
};
export type PdpSharedShippingInfo_item$data = PdpSharedShippingInfo_item;
export type PdpSharedShippingInfo_item$key = {
    readonly " $data"?: PdpSharedShippingInfo_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfo_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingInfo_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedCustomsMessage_item"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Literal",
          "name": "fetchShippingCostInfo",
          "value": true
        }
      ],
      "kind": "FragmentSpread",
      "name": "useShippingPrice_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'a4e1cb2a6bb549aba2e9ffef0410625e';
export default node;
